import api from '../../shared/api/axios';
import type { ServiceStatus, Service, ServiceCustomerDetailsOutput, ServiceLogOutput } from './types';

export const fetchServices = async () => {
    const { data } = await api.get<Service[]>('/services');
    return data;
};

export const fetchServiceStatuses = async () => {
    const { data } = await api.get<ServiceStatus[]>('/services/status');
    return data;
};

export const fetchServicesDetails = async () => {
    const { data } = await api.get<ServiceCustomerDetailsOutput[]>('/services/details');
    return data;
};

export const fetchServiceLog = async (params: { serviceId: number; eiffelCustomerId: string }) => {
    const { data } = await api.get<ServiceLogOutput>('/services/log', { params });
    return data;
};
